import { color } from "style/constants";

export default {
  root: {
    color: color.DARKGREEN,
    paddingLeft: "13px"
  }
};
